<template>
    <div class="background">
        <div style="background-color: #FFFFFF; width: 100%; height: 90%; margin: 10px 0 10px 10px">
              <div style="margin: 10px 0 20px 20px">
                    <div class="haeders1" style="font-size: 17px;">
                    <el-col :span="6">沉浸式项目管理
                    </el-col>
                    </div>
                    <div class="icon-container">
                        <el-col :span="18">
                            <el-col :span="10" class="style1">
                                <el-input
                                    placeholder="请输入内容"
                                    prefix-icon="el-icon-search"
                                    v-model="input2"
                                    size="small"
                                >
                                </el-input>
                            </el-col>
                            <el-col :span="8" style="margin-left: 10px;">
                                <div class="icon-container">
                                    <i class="el-icon-discover">筛选</i>
                                    <i class="el-icon-date">日期</i>
                                    <i class="el-icon-s-promotion">导出</i>
                                </div>
                            </el-col>
                        </el-col>
                    </div>
                    <div>
                        <el-col :span="10" style="margin-left: 10px; font-size: 15px;" class="haeders">
                            <i> 项目列表</i>
                            <i class="el-icon-folder-add" @click="createContent">创建新项目</i>
                        </el-col>
                        <el-col :span="10">
                            状态
                            <el-radio v-model="radio" label="1">全部</el-radio>
                            <el-radio v-model="radio" label="2">已支付</el-radio>
                            <el-radio v-model="radio" label="2">待支付</el-radio>
                            <el-radio v-model="radio" label="2">已过期</el-radio>
                        </el-col>
                    </div>
              </div>

            <div class="table_container" style="margin-top: 20px">
                <el-table
                    :data="tableData"
                    style="width: 100%"
                    :row-class-name="tableRowClassName"
                >
                   <el-table-column
                    type="selection"
                    width="40">
                </el-table-column>
                   <el-table-column
                        type="index"
                        label="序号"
                        width="50">
                    </el-table-column>
<!--                    <el-table-column-->
<!--                        label="项目ID"-->
<!--                        prop="id">-->
<!--                    </el-table-column>-->
                    <el-table-column
                        label="项目名称"
                        prop="name">
                    </el-table-column>
<!--                    <el-table-column-->
<!--                        label="分类"-->
<!--                        prop="classification">-->
<!--                    </el-table-column>-->
                    <el-table-column
                        label="场馆"
                        prop="address">
                    </el-table-column>
                    <el-table-column
                        label="站点"
                        prop="site_name">
                    </el-table-column>
                    <el-table-column
                        label="时间"
                        prop="time">
                    </el-table-column>
                    <el-table-column
                        label="状态"
                        prop="status">
                    </el-table-column>
                    <el-table-column label="操作" width="200">
                        <i class="el-icon-edit">设置</i>
                        <i class="el-icon-view">查看</i>
                    </el-table-column>
                </el-table>
            </div>
        </div>
    </div>
</template>

<script>
import $ from "jquery";

export default {
    name: "projectManagement",
    data() {
        return {
            tableData: [
                // {
                //     "id": 1, "title": "梦境空港之地球档案DreamPortal空间电影", "classification": "地球档案",
                //     "stadium": "梦境空港", "address": "上海", "date": "2024-11-26\n" +
                //         "2024-12-26", "status": "已上架"
                // },
                // {
                //     "id": 2, "title": "地球档案[第二季]", "classification": "地球档案1",
                //     "stadium": "梦境空港", "address": "上海", "date": "2024-11-26\n" +
                //         "2024-12-26", "status": "待上架"
                // },
            ],
        }
    },
  created() {
      this.getContentInfo()
  },
  methods: {
        tableRowClassName({row, rowIndex}) {
            if (rowIndex === 1) {
                return 'warning-row';
            } else if (rowIndex === 3) {
                return 'success-row';
            }
            return '';
        },
        getContentInfo(){
          var selectedValue = localStorage.getItem('selectedValue');
          console.log('选择的站', selectedValue)
            $.ajax({
                url: this.$settings.BASE_URL+'content/info',
                type: 'POST',
                data:{"site_id":selectedValue},
                dataType: 'json',
                  xhrFields: {
        withCredentials: true
    },
                success: (res) => {
                    console.log('获取到的数据888：', res)
                    let tableData = []
                    if (res.info == 'ok') {
                      res.contentList[0].content_info.forEach(function (content) {
                         var ticketTypeData = {
                                // id: content.name,
                                site_name:res.contentList[0].site_name,
                                name: content.name,
                                address: content.address,
                                date:content.time,
                                status: content.status
                            }
                            tableData.push(ticketTypeData)
                         console.log('tableDat44a',tableData)
                      })
                      console.log('tableData',this.tableData)
                        this.tableData = tableData
                    }
                },
                error: (error) => {
                    console.log('请求失败：', error)
                }
            })
        },
        createContent(){
           this.$router.push(`createContent`)
        },
    }
}
</script>

<style scoped>
.el-icon-folder-add {
    width:138px;
    height:41px;
    padding: 10px 8px 10px 8px;
    gap: 10px;
    border-radius: 8px;
    border: 1px solid #5C16F2;
    color: #5C16F2;
    font-size: 14px;

}

.background {
    background-color: #F4F5FA;
}

.el-icon-discover {

    width: 68px;
    height: 29px;
    border-radius: 4px 4px 4px 4px;
    border: 1px solid #5C16F2;
    color: #5C16F2;
    font-size: 14px;
}

.el-icon-date {
    width: 68px;
    height: 29px;
    border-radius: 4px 4px 4px 4px;
    opacity: 0px;
    border: 1px solid #5C16F2;
    color: #5C16F2;
    font-size: 14px;
}

.el-icon-s-promotion {
    width: 68px;
    height: 29px;
    border-radius: 4px 4px 4px 4px;
    opacity: 0px;
    border: 1px solid #5C16F2;
    color: #5C16F2;
    font-size: 14px;
}

.style1 {
    width: Hug (68px) px;
    height: Fixed (29px) px;
    border-radius: 4px 4px 4px 4px;
    border: 1px solid #5C16F2;
    text-align: center;
    justify-items: center;
    justify-content: center;
    margin: 0 10px 0 10px;
}

.icon-container {
    display: flex; /* 使用 Flexbox 布局 */
    justify-content: flex-end;
    gap: 10px; /* 设置图标之间的间距 */
}

/* 每个图标的样式 */
.icon-container i {
    display: flex; /* 让每个 i 标签成为 Flexbox 项 */
    align-items: center; /* 垂直居中文本 */
    justify-content: center; /* 水平居中文本 */
    border-radius: 4px; /* 可选：设置圆角 */
    /*border: 1px solid #5C16F2; !* 可选：设置边框 *!*/
    color: #5C16F2; /* 设置字体颜色 */
    font-size: 14px; /* 设置字体大小 */
    text-align: center; /* 确保文本水平居中 */
}

/*.haeders {*/
/*    color: #2D334A;*/
/*    font-family: PingFang SC;*/
/*    font-weight: 600;*/
/*    line-height: 30.8px;*/
/*    text-align: left;*/
/*    text-underline-position: from-font;*/
/*    text-decoration-skip-ink: none;*/
/*}*/
.haeders1 {
    color: #2D334A;
    font-family: PingFang SC;
    font-weight: 600;
    line-height: 30.8px;
    /*text-align: left;*/
    /*text-underline-position: from-font;*/
    /*text-decoration-skip-ink: none;*/
}

.el-table .warning-row {
    background: oldlace;
}

.el-table .success-row {
    background: #f0f9eb;
}

.el-icon-edit {
    /*width: 15px;*/
    /*height: 15px;*/
    /*background: #D6D0FF;*/
    /*border-radius: 10px;*/
    color:#5C16F2;

}
.el-icon-view{
    color:#5C16F2;
}
</style>
